import NavBar from 'src/components/UI/NavBar';
import WebHooksList from 'src/pages/PublicApiConsoleContainer/WebHooksList';
import Search from 'src/pages/PublicApiConsoleContainer/Search';
import WorkOrderDetails from 'src/pages/PublicApiConsoleContainer/WorkOrderDetails';

const PublicApiConsoleContainer = () => (
  <>
    <NavBar />
    <div className="api-console-container">
      <Search />
      <WorkOrderDetails />
      <WebHooksList />
    </div>
  </>
);

export default PublicApiConsoleContainer;
